import GraphModal from "graph-modal";

const GraphModalInit = () => {
  const modalCont = document.querySelector(".graph-modal");
  const modalMiframe = modalCont.querySelectorAll("iframe");
  const modal = new GraphModal({
    isClose: () => {
      modalMiframe.forEach((item) => {
        const src = item.src;
        item.src = "";
        item.src = src;
      });
    },
  });
};

export function modal() {
  GraphModalInit();
}
